/**
 * Created with IntelliJ IDEA.
 * User: liors
 * Date: 7/21/13
 * Time: 2:57 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var $ = require("jquery");
    var _ = require("underscore");
    var QuestionModel = require("models/entities/QuestionModel");
    var BaseCollection = require("collections/BaseCollection");

    var QuestionCollection = BaseCollection.extend({
        model: QuestionModel ,
        name: "QuestionCollection",
        initialize: function(models, options) {
            this.csatPositive= options.csatPositive;
            this.surveyType= options.surveyType;
        },
        reorderUpQuestion: function(question) {
            var index = this.indexOf(question);
            var newIndex = this._findPrevVisibleQuestion(index);
            if(newIndex != index && index !== 0) {
                this._swapQuestions(index, newIndex);
            }
        },

        reorderDownQuestion: function(question) {
            var index = this.indexOf(question);
            var newIndex = this._findNextVisibleQuestion(index);
            if(newIndex != index && newIndex < this.models.length) {
                this._swapQuestions(index, newIndex);
            }
        },
        updateQuestion: function(question, index) {
            this.at(index).set(question.attributes);
        },
        hasCsatDefined: function(){
            var obj = _.find(this.models, function (model) {
                return model.isCSAT() === true && model.getDisplay();
            });
            return !_.isUndefined(obj);
        },
        hasNameDefined: function(){
            var obj = _.find(this.models, function (model) {
                return model.isName() === true && model.getDisplay();
            });
            return !_.isUndefined(obj);
        },
        hasFirstNameDefined: function(){
            var obj = _.find(this.models, function (model) {
                return model.isFirstName() && model.getDisplay();
            });
            return !_.isUndefined(obj);
        },
        hasLastNameDefined: function(){
            var obj = _.find(this.models, function (model) {
                return model.isLastName() && model.getDisplay();
            });
            return !_.isUndefined(obj);
        },
        hasEmailDefined: function(){
            var obj = _.find(this.models, function (model) {
                return model.isEmail() === true && model.getDisplay();
            });
            return !_.isUndefined(obj);
        },
        hasMessageDefined: function(){
            var obj = _.find(this.models, function (model) {
                return model.isMessage() === true && model.getDisplay();
            });
            return !_.isUndefined(obj);
        },
        getCsatQuestion: function(){
            return _.find(this.models, function (model) {
                return model.isCSAT() === true;
            });
        },
        getSurveyBasedRoutingQuestion: function(){
            return _.find(this.models, function (model) {
                return model.isSurveyBasedRouting() === true;
            });
        },
        hasSurveyBasedRoutingDefined: function(){
            var obj = _.find(this.models, function (model) {
                return model.isSurveyBasedRouting() === true && model.getDisplay();
            });
            return !_.isUndefined(obj);
        },
        getNewLogicID: function() {
            var finalId = 1;
            var newId;
            _.forEach(this.models, function(values, key) {
                newId = values.getLogicID();
                if(newId + 1 > finalId) {
                    finalId = newId + 1;
                }
            });
            return finalId;
        },
        addNewQuestion: function(type) {
            var newQuestion = new QuestionModel();
            newQuestion.setQuestion(window.LE.translator.translate("LECampaigns.engagementWindow.survey.question.add.name"));
            newQuestion.setUDEScope(QuestionModel.UDE_SCOPES.SESSION);
            newQuestion.setGlobalName("");
            newQuestion.setDisplay(true);
            newQuestion.setId(this.getNewLogicID());
            newQuestion.setEditMode(type ? true : false);

            if (type == ROUTING_QUESTION) {
                newQuestion.setUDEType(QuestionModel.UDE_TYPES.DROPDOWN_BOX);
                newQuestion.setType(QuestionModel.QUESTION_TYPES.ROUTING);
                newQuestion.setIsSpecialQuestion(true);
            } else {
                newQuestion.setUDEType( type || QuestionModel.UDE_TYPES.TEXT_FIELD);
            }

            this.add(newQuestion);
        },
        duplicateQuestion: function(question) {
            var dupQuestion = this._duplicate(question);

            // clean fields to prevent collision
            dupQuestion.setGlobalName("");
            dupQuestion.setUDEScope(QuestionModel.UDE_SCOPES.SESSION);
            dupQuestion.setId(this.getNewLogicID());
            this.add(dupQuestion);
        },

        duplicateSpecialQuestion: function (question) {
            // This function will duplicate the special question, make it hidden and put it into the end of the list
            // The new question will be the same settings like the special question but visible, and it's lost its special flag

            var dupQuestion = this._duplicate(question);
            var orgQuestion = this._duplicate(question);

            //change in the clone
            dupQuestion.setId(this.getNewLogicID());
            dupQuestion.setDisplay(false);
            dupQuestion.setRequired(false);

            // change the original
            orgQuestion.setGlobalName("");
            orgQuestion.setIsSpecialQuestion(false);
            orgQuestion.setType(QuestionModel.QUESTION_TYPES.DEFAULT);

            var index = this.indexOf(question);

            this.updateQuestion(orgQuestion, index);
            this.add(dupQuestion);
        },

        /***** internal functions ******/
        _duplicate: function(question){
            var dupQuestion = new QuestionModel();
            // copy the values of the original question to the new one
            dupQuestion.attributes = $.extend(true, {}, question.attributes);
            return dupQuestion;
        },

        /*********** internal functions for reordering **********/
        _findNextVisibleQuestion: function(index) {
            var newIndex = index;
            for(var i = index + 1; i < this.models.length; i++) {
                var displayed = this.models[i].getDisplay();
                if(displayed) {
                    newIndex = i;
                    break;
                }
            }
            return newIndex;
        },

        _findPrevVisibleQuestion: function(index) {
            var newIndex = index;
            for(var i = index - 1; i >= 0; i--) {
                var displayed = this.models[i].getDisplay();
                if(displayed) {
                    newIndex = i;
                    break;
                }
            }
            return newIndex;
        },
        _swapQuestions: function (index1, index2) {
            var tmp1 = this.at(index1).clone();
            var tmp2 = this.at(index2).clone();

            this.updateQuestion(tmp2, index1);
            this.updateQuestion(tmp1, index2);
        }
    });


    var ROUTING_QUESTION = "Survey Based Routing";

    return QuestionCollection;
});
